/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 1c70d1ef2eba8c9fed49d31f6ff0a4c9bda9c00ec71e936ea62e95f26b69f1ec
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './Pill.style'

type PillOwnProps = {
  className?: string
  iconLeft?: React.ReactNode
  iconRight?: React.ReactNode
  size?: 'small' | 'medium' | 'large'
  type?: 'default' | 'highlight' | 'severe' | 'pending' | 'saas' | 'aiNew'
}

export type PillProps = PillOwnProps & Omit<ComponentProps<'span'>, keyof PillOwnProps>

function Pill(props: PillProps): ReactElement {
  const {
    children,
    className = '',
    iconLeft,
    iconRight,
    size = 'medium',
    type = 'default',
    ...rest
  } = props

  return (
    <span
      className={cn('Pill', className, size, type)}
      css={style}
      {...rest}
      role={rest.role ?? 'status'}
    >
      {iconLeft}
      {children}
      {iconRight}
    </span>
  )
}

export default Pill
